/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessLogsSchema
 */
export interface ProcessLogsSchema {
    /**
     * 
     * @type {string}
     * @memberof ProcessLogsSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogsSchema
     */
    logs: string;
}

/**
 * Check if a given object implements the ProcessLogsSchema interface.
 */
export function instanceOfProcessLogsSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "logs" in value;

    return isInstance;
}

export function ProcessLogsSchemaFromJSON(json: any): ProcessLogsSchema {
    return ProcessLogsSchemaFromJSONTyped(json, false);
}

export function ProcessLogsSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessLogsSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'logs': json['logs'],
    };
}

export function ProcessLogsSchemaToJSON(value?: ProcessLogsSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'logs': value.logs,
    };
}

